import LotteryService from "src/services/LotteryService";
import ModuleCreator from "../ModuleCreator";

export const types = {};
export const params = {
	title:"",
	description:"",
	start_at:"",
	end_at:"",
	price:"",
	is_default:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.lottery,
@property  {array}  modules.lotteries
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator({name:"lottery",plural:"lotteries"}, LotteryService, module, types ,params);
